<!-- src/views/DashboardView.vue -->

<template>
  <div class="row">
    <div class="col-xxl-6">
      <!--begin::Engage widget 10-->
      <div class="card card-flush h-md-100">
        <!--begin::Body-->
        <div
          class="card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0"
        >
          <div class="mb-10">
            <div class="col-xl-12 features">
              <div class="d-flex h-100 align-items-center">
                <div
                  class="w-100 d-flex flex-column flex-center rounded-3 bg-light bg-opacity-75 p-2"
                >
                  <div class="mb-7 text-center">
                    <h1 class="text-dark mb-1 fw-bolder">
                      {{ $t("common.app_name") }}
                    </h1>
                    <div class="text-gray-400 fw-semibold mb-1">
                      <br />{{ $t("auth.tagline") }}
                    </div>
                  </div>
                  <img
                    class="mx-auto h-100px h-lg-100px theme-light-show"
                    style="width: 120px; height: 120px !important"
                    src="assets/img/2.png"
                    alt=""
                  />

                  <div class="w-100 mb-10">
                    <div class="d-flex align-items-center mb-5 box">
                      <span
                        class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"
                      >
                        {{ $t("home.infoDetails.features.support") }}
                      </span>
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span
                        class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"
                      >
                        {{ $t("home.infoDetails.features.payments") }}
                      </span>
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span
                        class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"
                      >
                        {{
                          $t("home.infoDetails.features.custom_bundles")
                        }}</span
                      >
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span
                        class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"
                        >{{
                          $t("home.infoDetails.features.live_courses")
                        }}</span
                      >
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Body-->
      </div>
      <!--end::Engage widget 10-->
    </div>

    <div class="col-xxl-6 info-box">
      <div class="card card-flush h-md-100">
        <div
          class="card-body d-flex flex-column mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0"
        >
          <img
            class="mx-auto h-150px h-lg-200px theme-light-show"
            src="assets/img/s1.png"
            alt=""
          />
          <img
            style="
              border: 10px solid #a3a3a314;
              border-radius: 10px;
              padding: 10px;
            "
            class="mx-auto h-150px h-lg-200px theme-dark-show"
            src="assets/img/s1.png"
            alt=""
          />
          <div class="mt-20">
            <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
              <span class="me-2">
                {{ $t("home.infoDetails.hero.headline_prefix") }}
                <span class="position-relative d-inline-block text-success">
                  <a
                    href="../../demo1/dist/pages/user-profile/overview.html"
                    class="text-success opacity-75-hover"
                  >
                    {{ $t("home.infoDetails.hero.cta_app_name") }}</a
                  >
                  <span
                    class="position-absolute opacity-15 bottom-0 start-0 border-4 border-success border-bottom w-100"
                  ></span>
                </span>
                {{ $t("home.infoDetails.hero.headline_suffix") }}
              </span>
              {{ $t("home.infoDetails.trailer") }}
            </div>
            <span class="fw-semibold text-center fs-6 mb-8 d-block opacity-75">
              {{ $t("auth.promo_text") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "infoDetails",
  data() {
    return {
      banners: [],
    };
  },
  async mounted() {},
  methods: {},
};
</script>
<style scoped>
/* ========== Animations ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* ========== Row Container ========== */
.row {
  animation: fadeInUp 0.6s ease forwards;
}

/* ========== Cards ========== */
.card {
  border-radius: 24px !important;
  border: 1px solid rgba(0, 196, 68, 0.08) !important;
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  box-shadow: 0 10px 40px rgba(0, 196, 68, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
}
.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 60px rgba(0, 196, 68, 0.12);
  border-color: rgba(0, 196, 68, 0.15) !important;
}

.card-body {
  padding: 30px;
}

/* ========== Features Section ========== */
.features {
  position: relative;
}

.features .rounded-3 {
  border-radius: 20px !important;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%) !important;
  padding: 30px !important;
  border: 1px solid rgba(0, 196, 68, 0.1);
}

.features h1 {
  font-size: 1.8rem !important;
  font-weight: 800 !important;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.features img {
  animation: float 3s ease-in-out infinite;
  filter: drop-shadow(0 10px 20px rgba(0, 196, 68, 0.2));
}

/* ========== Feature Box ========== */
.box {
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  padding: 16px 20px;
  border-radius: 14px;
  border: 1px solid rgba(0, 196, 68, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 12px !important;
}
.box:hover {
  transform: translateX(-5px);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.1);
  border-color: rgba(0, 196, 68, 0.2);
}

.box .fw-semibold {
  font-weight: 600 !important;
  color: #1a1a2e;
}

.box .svg-icon i {
  font-size: 1.3rem;
  color: #00c444;
  transition: transform 0.3s ease;
}
.box:hover .svg-icon i {
  transform: scale(1.2);
}

/* ========== Info Box ========== */
.info-box .card {
  position: relative;
  overflow: hidden;
}
.info-box .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.info-box img {
  animation: float 4s ease-in-out infinite;
  filter: drop-shadow(0 15px 30px rgba(0, 196, 68, 0.15));
  border-radius: 16px;
}

.info-box .fs-2 {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  line-height: 1.8;
  color: #1a1a2e;
}

.info-box .text-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800 !important;
  position: relative;
}
.info-box .text-success::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #00c444, #00e050);
  border-radius: 2px;
  opacity: 0.3;
}

.info-box .border-success {
  border-color: rgba(0, 196, 68, 0.3) !important;
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .card,
[data-theme="dark"] .card,
.dark .card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}
[data-bs-theme="dark"] .card:hover,
[data-theme="dark"] .card:hover,
.dark .card:hover {
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);
  border-color: rgba(0, 196, 68, 0.2) !important;
}

[data-bs-theme="dark"] .features .rounded-3,
[data-theme="dark"] .features .rounded-3,
.dark .features .rounded-3 {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%) !important;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .features h1,
[data-theme="dark"] .features h1,
.dark .features h1 {
  background: linear-gradient(135deg, #00e050 0%, #8bffb3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .box,
[data-theme="dark"] .box,
.dark .box {
  background: linear-gradient(145deg, #3a3b3c 0%, #2d2e30 100%);
  border-color: rgba(0, 196, 68, 0.1);
}
[data-bs-theme="dark"] .box:hover,
[data-theme="dark"] .box:hover,
.dark .box:hover {
  border-color: rgba(0, 196, 68, 0.25);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .box .fw-semibold,
[data-theme="dark"] .box .fw-semibold,
.dark .box .fw-semibold {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .box .svg-icon i,
[data-theme="dark"] .box .svg-icon i,
.dark .box .svg-icon i {
  color: #00e050;
}

[data-bs-theme="dark"] .text-gray-400,
[data-theme="dark"] .text-gray-400,
.dark .text-gray-400 {
  color: #b0b3b8 !important;
}

[data-bs-theme="dark"] .text-gray-700,
[data-theme="dark"] .text-gray-700,
.dark .text-gray-700 {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .text-gray-800,
[data-theme="dark"] .text-gray-800,
.dark .text-gray-800 {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .info-box .fs-2,
[data-theme="dark"] .info-box .fs-2,
.dark .info-box .fs-2 {
  color: #e4e6eb;
}

[data-bs-theme="dark"] .info-box .text-success,
[data-theme="dark"] .info-box .text-success,
.dark .info-box .text-success {
  background: linear-gradient(135deg, #00e050 0%, #8bffb3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .text-dark,
[data-theme="dark"] .text-dark,
.dark .text-dark {
  color: #e4e6eb !important;
}
</style>
